export const entryStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '12px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow?.s,
};

export const entryHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
};
